import React from 'react'
import AnimateImageFour from './AnimateImageFour'
import AnimateTitleFour from './AnimatedTitleFour'

const QualityControl = () => {
    return (
        <section className='section-quality-control-two section-padding'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-5'>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>As a socially compliant and ethically conscious organization, we take pride in creating a safe, inclusive, and inspiring workplace. Our facilities are audited annually by independent agencies on behalf of global clients, ensuring that our operations meet the highest international standards of social and environmental responsibility.</p>
                        <p>We believe true luxury is mindful — one that respects people, processes, and the planet. Sustainability is woven into our philosophy, from responsibly sourcing materials to embracing upcycling and waste reduction throughout our production cycle. Every garment we create is not only a testament to artistry but also to accountability — fashion that feels as good as it looks.</p>
                     </div>
                   </div>
                </div>
                <div className='col-md-7'>
                    <div className='section-img-heading'>
                     <div className='section-title'>
                        <AnimateTitleFour/>
                     </div>
                    <div className='animated-image-wrapper'>
                        <AnimateImageFour/>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default QualityControl